import { useMutation } from "@apollo/client";

import { ProjectReviewVisitV2ObservationList_BulkApproveDocument } from "../mutations.generated";
import { ProjectReviewVisitV2ObservationList_GetDataDocument } from "../queries.generated";

export function useProjectReviewVisitV2ObservationList_BulkApprove(visitId: string) {
    const [mutate, { loading, error }] = useMutation(ProjectReviewVisitV2ObservationList_BulkApproveDocument, {
        variables: {
            input: {
                plannerVisitId: visitId,
            },
        },
        refetchQueries: [ProjectReviewVisitV2ObservationList_GetDataDocument],
    });

    const bulkApprove = async () => {
        await mutate();
    };

    return {
        bulkApprove,
        loading,
        error,
    };
}
